import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";

interface AppointmentTypes {
  PendingAppointment: appointmentTypes[];
  UpcomingAppointment: appointmentTypes[];
  CompletedAppointment: appointmentTypes[];
  CancelledAppointment: appointmentTypes[];
  loading: boolean;
}

const initialState: AppointmentTypes = {
  PendingAppointment: [],
  UpcomingAppointment: [],
  CompletedAppointment: [],
  CancelledAppointment: [],
  loading: false,
};

const AppointmentSlice = createSlice({
  name: "appointment",
  initialState,
  reducers: {},

});

export default AppointmentSlice;
